<template>
  <div
    class="icon-button text-green-600 hover:bg-green-200 hover:text-black"
    >
    <svg
        viewBox="0 0 24 24"
        class="w-5 h-5"
        fill="currentColor"
        stroke-width="1"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11 16V7.85l-2.6 2.6L7 9l5-5l5 5l-1.4 1.45l-2.6-2.6V16zm-5 4q-.825 0-1.412-.587T4 18v-3h2v3h12v-3h2v3q0 .825-.587 1.413T18 20z"/>
    </svg>
  </div>
</template>